export const DashBoard = {
  pass: {
    currColor: '#FFC813',
    expectColor: '#77c9ff',
    textColor: '#FFF'
  },
  unPass: {
    currColor: '#FD5407',
    expectColor: '#BBBBBB',
    textColor: '#FD5407'
  }
}
export interface IHomeData {
  // 分数
  point: number
  // 近7日分数记录的第一条记录
  pointListOne: string
  // 状态变更的第一条记录
  statusChangeListOne: string

  /* ===通过字段=== */
  // 更新时间
  updateTime: string

  /* ===未通过字段=== */
  // 整改次数
  improvementNum: number

  // 任务1的状态 1 完成 0 未完成
  task1Status: TASK_STATUS

  // 任务2的闭关时间（小时）
  task2RuleTime: string

  // 任务2的服务器当前时间
  task2ServerCurrTime: number
  // 任务2的服务器到期时间
  task2ServerExpireTime: number

  // 任务2的状态 1 完成 0 未完成
  task2Status: TASK_STATUS
}
export enum USER_STATUS {
  stopCount = 0,
  normal,
  abnormal
}
export enum TASK_STATUS {
  unfinished = 0,
  finished
}
